import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../../config/firebase';

const provider = new GoogleAuthProvider();

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    console.log("res:", result);
    return result.user;
  } catch (error: any) {
    console.error('Google auth error:', error);
    throw error;
  }
};